const API_URL = process.env.REACT_APP_API_URL_PROD;

export async function postFeedback({ name, email, message, type }) {
    const apiUrl = `${API_URL}/feedbacks/`;

    const payload = {
        name,
        email,
        message,
        type, // 'error', 'bug' немесе 'message'
    };

    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Беймәлім қате орын алды');
        }

        return {
            success: true,
            message: data.message,
        };
    } catch (error) {
        return {
            success: false,
            error: error.message,
        };
    }
}  